import {BookOfShadowsGameConfig} from "../BookOfShadowsGameConfig";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

require("pixi-particles");

export class CoinsFountain extends BaseView {

    private readonly _screenHeightRange: [number, number] = [720, 1760];
    private readonly _startSpeedRange: [number, number] = [750, 1150];
    private readonly _startSpeedRangeEmbers: [number, number] = [650, 950];

    private readonly _initMaxParticles: number = 130;

    private readonly _embersConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.6,
                "end": 0.1,
                "minimumScaleMultiplier": 0.5
            },
            "color": {
                "start": "#ffd991",
                "end": "#ed0000"
            },
            "speed": {
                "start": 1000,
                "end": 400,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 270,
                "max": 280
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 0,
                "max": 200
            },
            "lifetime": {
                "min": 0.11,
                "max": 1.3
            },
            "blendMode": "add",
            "ease": [
                {
                    "s": 0,
                    "cp": 0.379,
                    "e": 0.548
                },
                {
                    "s": 0.548,
                    "cp": 0.717,
                    "e": 0.676
                },
                {
                    "s": 0.676,
                    "cp": 0.635,
                    "e": 1
                }
            ],
            "frequency": 0.015,
            "emitterLifetime": -1,
            "maxParticles": 463,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": BookOfShadowsGameConfig.instance.REEL_AREA_POS_X + 25,
                "y": BookOfShadowsGameConfig.instance.GAME_HEIGHT,
                "w": BookOfShadowsGameConfig.instance.REEL_AREA_WIDTH - 50,
                "h": 1
            }
        }
    ];

    private readonly _coinsConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.5,
                "end": .7,
                "minimumScaleMultiplier": .8
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 600,
                "end": 200,
                "minimumSpeedMultiplier": 1.5
            },
            "acceleration": {
                "x": 0,
                "y": 2800
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 235,
                "max": 310
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "blendMode": "normal",
            "frequency": 0.02,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 360,
                "y": 720 + 40,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -5,
                "y": 0,
                "w": 10,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.7,
                "end": 1,
                "minimumScaleMultiplier": .7
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 500,
                "end": 200,
                "minimumSpeedMultiplier": 1.5
            },
            "acceleration": {
                "x": 0,
                "y": 2800
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 235,
                "max": 310
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "blendMode": "add",
            "frequency": 0.06,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 360,
                "y": 720 + 40,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -5,
                "y": 0,
                "w": 10,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.5,
                "end": 1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 450,
                "end": 200,
                "minimumSpeedMultiplier": 1.5
            },
            "acceleration": {
                "x": 0,
                "y": 2800
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 235,
                "max": 310
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "blendMode": "normal",
            "frequency": 0.06,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 360,
                "y": 720 + 40,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -5,
                "y": 0,
                "w": 10,
                "h": 1
            }
        }
    ];

    private _embersEmitters: Emitter[];
    private _coinsEmitters: Emitter[];
    private _layer: ScalableLayer;
    private _container: PIXI.Container;

    private _isPlaying: boolean = false;
    private readonly _particleMaxLife: number = 2;

    /**
     * @description To start the fountain.
     * @param playLevel
     */
    public startFountain(playLevel: number): void {
        if (!this._isPlaying) {
            this._isPlaying = true;
        }

        if (this._isResizeDirty) {
            this.onResize(this._resizeData);
        }

        this._coinsEmitters.forEach((emitter: Emitter, level: number) => {
            if (level < playLevel) {
                emitter.maxParticles /= 2;
            }

            if (level <= playLevel) {
                emitter.emit = true;
            }
        });

        if (playLevel === 2) {
            this._embersEmitters.forEach((emitter: Emitter) => {
                emitter.emit = true;
            });
        }
    }

    /**
     * @description To start the fountain for FS outro.
     */
    public startFountainForOutro(): void {
        // changing the layer of container so that it gets on top of outro items except continue button which is handled in outro view class.
        StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.FREE_SPIN.name).addChild(this._container);

        for (let i: number = 0; i < 3; i++) {
            this.startFountain(i);
        }
    }

    /**
     * @description To stop the fountain.
     */
    public stopFountain(): void {
        // resetting the container's layer.
        this._layer.addChild(this._container);

        this._isPlaying = false;
        this._coinsEmitters.forEach((emitter: Emitter) => {
            emitter.emit = false;

            emitter.maxParticles = this._initMaxParticles;
        });

        this._embersEmitters.forEach((emitter: Emitter) => {
            emitter.emit = false;
        });
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        this._layer = StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.BIG_WIN_FOUNTAIN.name);
        this._container = new PIXI.Container();
        this._layer.addChild(this._container);

        this._embersEmitters = [];
        this._embersConfigs.forEach((config: any, level: number) => {
            const emitterContainer: PIXI.Container = new PIXI.Container();
            this._container.addChild(emitterContainer);
            const emitter: Emitter = new Emitter(emitterContainer, [{
                framerate: 30,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures("bigWinEmber")
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._embersEmitters.push(emitter);
        });

        this._coinsEmitters = [];
        this._coinsConfigs.forEach((config: any, level: number) => {
            const emitterContainer: PIXI.Container = new PIXI.Container();
            this._container.addChild(emitterContainer);
            const emitter: Emitter = new Emitter(emitterContainer, [{
                framerate: 30,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures(`bigWinCoin${level}`)
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmitters.push(emitter);
        });
    }

    /**
     * @inheritDoc
     * @param resizeData
     */
    protected onResize(resizeData: IResizeData): void {
        this._resizeData = resizeData;

        if (!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;

        let screenHeight = Math.max(this._screenHeightRange[0], Math.min(resizeData.height, this._screenHeightRange[1]));
        const startSpeedEmbers: number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRangeEmbers[1] - this._startSpeedRangeEmbers[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRangeEmbers[0]);
        const startSpeed: number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        const y: number = (resizeData.height - ((resizeData.height - 720) / 2)) + 30;
        this._coinsEmitters.forEach((emitter: Emitter, level: number) => {
            emitter.cleanup();
            emitter.startSpeed.value = startSpeed * (1 + (0.15 * level));
            emitter.spawnPos.y = y;
            emitter.maxLifetime = MathHelper.ceilToDecimals(this._particleMaxLife * (resizeData.height / 720), 2);
        });

        this._embersEmitters.forEach((emitter: Emitter, level: number) => {
            emitter.cleanup();
            emitter.startSpeed.value = startSpeedEmbers * (1 + (0.05 * level));

            if (resizeData.orientation === Orientation.PORTRAIT) {
                emitter.spawnPos.y = 250;
            } else {
                emitter.spawnPos.y = 0;
            }
        });
    }
}